<template>
  <div v-if="marketData" class="mt-[20px] flex  overflow-hidden flex-grow ">

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden h-full  flex  text-center justify-center">



          <div class="flex flex-wrap gap-[2px]">

              <div v-for="project in projectData" :key="project.projectId" class="bg-trader-darker-gray text-white px-[5px] h-[25px] flex flex-row items-center hover:bg-trader-blue hover:text-white cursor-pointer"
                   :class="{ 'bg-trader-blue text-white': selectedProjectId === project.projectId }"
                   @click="getMagazines(project.projectId)">

                <span>{{ project.name }}</span>
              </div>

            <div class="w-full">
              <div v-for="magazine in magazines" :key="magazine.magazineId">

                <!-- Flex-Container mit Justify-Between für Titel und Button -->
                <div class="flex text-white justify-between items-center bg-trader-darkest-gray h-6 cursor-pointer w-full mt-5 mb-1">
                  <div class="w-full h-full text-center justify-center flex flex-col ">
                    <span>{{ magazine.name }}</span>
                  </div>
                  <button class="h-full bg-trader-green w-[150px] text-trader-dark-green hover:bg-trader-blue hover:text-white cursor-pointer">Alle Seiten exportieren</button>
                </div>

                <!-- Flex-Container für die Seiten, der umbricht, wenn er den Bildschirmrand erreicht -->
                <div class="grid grid-cols-12 flex-wrap items-center gap-[2px] rounded w-full">
                  <div v-for="page in magazine.pages" :key="page.pageId"
                       class="bg-primary hover:bg-trader-blue hover:text-white cursor-pointer">

                    <div v-if="page.marketId > 0" class="text-left flex">
                      <span class="text-trader-darkest-gray bg-trader-dark-gray mr-2 grow-1 px-2"> {{ page.pagePosition }}</span>
                      <span v-if="marketData.filter(item => item.marketId == page.marketId)[0]?.name != null">
                        {{ marketData.filter(item => item.marketId == page.marketId)[0]?.name }}
                      </span>
                    </div>
                    <span v-else>{{ page.pagePosition }} </span>

                  </div>
                </div>

              </div>
            </div>
          </div>

    </div>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import router from "@/router";
import apolloClient from "@/apolloClient";
import {mapActions, mapState} from "vuex";

export default {
  data() {
    return {
      projects: [],
      selectedProjectId: null,
      selectedMagazines: null,
      projectData: [],
      magazines: [],
      pages: [],
    }
  },
  computed: {
    ...mapState('market', ['marketData']),
  },
  methods: {
    ...mapActions('market', ['fetchMarketData']),
    magazine() {
      return magazine
    },
    goBack() {
      router.push(`/project`);
    },
    async getProjects() {
      try {
        const response = await apolloClient.query({
          query: gql`
        query GetProjectDetails {
          projects {
            projectId
            name
          }
        }
      `
        });
        this.projectData = Array.isArray(response.data.projects) ? response.data.projects : [response.data.projects];
      } catch (error) {
        console.error("Fehler beim Abrufen der Projektdaten:", error);
      }
    },

    async getMagazines(projectId) {
      this.selectedProjectId = projectId
      try {
        const response = await apolloClient.query({
          query: gql`
        query magazines($filter: QueryFilter) {
          magazines(filter: $filter) {
             magazineId
             name
             pages {
                marketId

                pageId
                pagePosition
             }
          }
        }
      `,
          variables: {
            filter: {
              projectId: projectId
            }
          }
        });

        this.magazines = response.data.magazines
        // soll für jedes magazine die pages holen
        for (let i = 0; i < this.magazines.length; i++) {
          await this.getPages(this.magazines[i].magazineId)
        }
      } catch (error) {
        console.error("Fehler beim Abrufen der Pages:", error);
      }
    },
  },
  mounted() {
    this.getProjects();
    this.fetchMarketData();
  },
  watch: {},
  created() {

  }
};
</script>
